// Collection Carousel (custom) — vanilla JS, no external dependencies.
// Handles the desktop prev/next arrows; mobile relies on native scroll/swipe.

(function () {
  'use strict';

  function initCarousel(root) {
    var track = root.querySelector('.collection-carousel-cs__track');
    var prevBtn = root.querySelector('.collection-carousel-cs__arrow--prev');
    var nextBtn = root.querySelector('.collection-carousel-cs__arrow--next');
    if (!track) return;

    function scrollByAmount(direction) {
      var item = track.querySelector('.collection-carousel-cs__item');
      if (!item) return;

      var itemWidth = item.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).gap || '0');
      var amount = (itemWidth + gap) * 2 * direction; // scroll ~2 items per click

      track.scrollBy({ left: amount, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByAmount(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByAmount(1);
      });
    }
  }

  function initAll() {
    var carousels = document.querySelectorAll('.collection-carousel-cs');
    carousels.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a new instance is added via the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var newRoot = event.target.querySelector('.collection-carousel-cs');
    if (newRoot) initCarousel(newRoot);
  });
})();
